import React from "react";
import { X } from "lucide-react";
import { useTranslation } from "react-i18next";

interface TermsModalProps {
  isOpen: boolean;
  onClose: () => void;
}

const TermsModal: React.FC<TermsModalProps> = ({ isOpen, onClose }) => {
  const { t } = useTranslation();
  if (!isOpen) return null;

  return (
    <div className="fixed inset-0 bg-black bg-opacity-50 z-50 flex items-center justify-center p-4">
      <div className="bg-gray-800 rounded-lg max-w-4xl max-h-[90vh] overflow-y-auto dropdown-scrollbar">
        <div className="sticky top-0 bg-gray-800 border-b border-gray-700 px-6 py-4 flex justify-between items-center">
          <h2 className="text-2xl font-bold text-white">
            {t("1188", "Terms and Conditions")}
          </h2>
          <button
            onClick={onClose}
            aria-label={t("1189", "Close terms and conditions")}
            className="text-gray-400 hover:text-white transition-colors"
          >
            <X size={24} />
          </button>
        </div>

        <div className="px-6 py-6 space-y-6">
          <section>
            <h3 className="text-lg font-semibold text-white mb-3">
              {t("1190", "Service Agreement")}
            </h3>
            <p className="text-gray-300 leading-relaxed">
              {t(
                "1191",
                "By using TaxiSchipholAirport services, you agree to these terms and conditions. Our services include airport transfers, city transportation, and tour services throughout the Netherlands and Europe."
              )}
            </p>
          </section>

          <section>
            <h3 className="text-lg font-semibold text-white mb-3">
              {t("1192", "Booking and Payment")}
            </h3>
            <p className="text-gray-300 leading-relaxed">
              {t(
                "1193",
                "All bookings must be confirmed in advance. Payment can be made in cash, by card, or bank transfer. Prices are fixed and agreed upon booking confirmation. Additional charges may apply for waiting time, tolls, or parking fees."
              )}
            </p>
          </section>

          <section>
            <h3 className="text-lg font-semibold text-white mb-3">
              {t("1194", "Cancellation Policy")}
            </h3>
            <p className="text-gray-300 leading-relaxed">
              {t(
                "1195",
                "Cancellations must be made at least 2 hours before the scheduled pickup time. Late cancellations may incur charges. We reserve the right to cancel services due to weather conditions or other circumstances beyond our control."
              )}
            </p>
          </section>

          <section>
            <h3 className="text-lg font-semibold text-white mb-3">
              {t("1196", "Liability and Insurance")}
            </h3>
            <p className="text-gray-300 leading-relaxed">
              {t(
                "1197",
                "All vehicles are fully insured and licensed. TaxiSchipholAirport is not liable for delays caused by traffic, weather, or other external factors. Passengers are responsible for their personal belongings during transport."
              )}
            </p>
          </section>

          <section>
            <h3 className="text-lg font-semibold text-white mb-3">
              {t("1198", "Contact Information")}
            </h3>
            <p className="text-gray-300 leading-relaxed">
              {t(
                "1199",
                "For questions about these terms, contact us at info@taxischipholairport.net or +31 6 39182624. Our business is registered in the Netherlands with KVK number 69753938."
              )}
            </p>
          </section>
        </div>

        <div className="sticky bottom-0 bg-gray-700 px-6 py-4 border-t border-gray-600">
          <button
            onClick={onClose}
            className="bg-primary text-white px-6 py-2 rounded-lg hover:bg-primary-dark transition-colors"
          >
            {t("1200", "Close")}
          </button>
        </div>
      </div>
    </div>
  );
};

export default TermsModal;
